import React from 'react';

export const FlagIcon = ({
  width = '40',
  height = '40',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M6.6665 24.9987C6.6665 24.9987 8.33317 23.332 13.3332 23.332C18.3332 23.332 21.6665 26.6654 26.6665 26.6654C31.6665 26.6654 33.3332 24.9987 33.3332 24.9987V4.9987C33.3332 4.9987 31.6665 6.66536 26.6665 6.66536C21.6665 6.66536 18.3332 3.33203 13.3332 3.33203C8.33317 3.33203 6.6665 4.9987 6.6665 4.9987V24.9987ZM6.6665 24.9987V36.6654"
      stroke="#3966E0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
